import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value, tipo:any) {
    if(tipo == 'style'){
      return this.sanitizer.bypassSecurityTrustStyle(value);
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/safe.pipe.ts